module.exports = __webpack_public_path__ + "img/C05TechEnnerisChampion_ua.344ffcaf.webp";